import { render, staticRenderFns } from "./ListadoPagosUniversidadesAgrupados.vue?vue&type=template&id=4f5f0c3a"
import script from "./ListadoPagosUniversidadesAgrupados.vue?vue&type=script&lang=js"
export * from "./ListadoPagosUniversidadesAgrupados.vue?vue&type=script&lang=js"
import style0 from "./ListadoPagosUniversidadesAgrupados.vue?vue&type=style&index=0&id=4f5f0c3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports